var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEloBrand = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 100 100",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsXodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo-brand.svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M15.59 39.3c1.12,-0.37 2.32,-0.57 3.57,-0.57 5.45,0 10.01,3.87 11.05,9.02l7.73 -1.58c-1.77,-8.74 -9.51,-15.33 -18.78,-15.33 -2.13,0 -4.16,0.35 -6.07,0.99l2.5 7.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M6.46 64.35l5.23 -5.91c-2.33,-2.06 -3.8,-5.08 -3.8,-8.44 0,-3.36 1.47,-6.38 3.8,-8.44l-5.23 -5.91c-3.96,3.51 -6.46,8.64 -6.46,14.35 0,5.71 2.5,10.84 6.46,14.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M30.21 52.26c-1.05,5.14 -5.6,9.01 -11.05,9.01 -1.25,0 -2.45,-0.2 -3.57,-0.58l-2.51 7.49c1.92,0.63 3.96,0.98 6.08,0.98 9.27,0 17,-6.58 18.78,-15.31l-7.73 -1.59z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M44.7 58.69c-0.26,-0.41 -0.6,-1.07 -0.81,-1.55 -1.22,-2.85 -1.28,-5.79 -0.25,-8.61 1.14,-3.1 3.31,-5.47 6.12,-6.67 3.53,-1.52 7.42,-1.23 10.81,0.78 2.14,1.23 3.66,3.13 4.82,5.82 0.15,0.35 0.28,0.72 0.41,1.03l-21.1 9.2zm7.05 -12.27c-2.51,1.08 -3.8,3.43 -3.53,6.18l10.61 -4.57c-1.83,-2.14 -4.2,-2.85 -7.08,-1.61zm8.4 9.94c-0.01,0 -0.01,0.01 -0.01,0.01l-0.22 -0.15c-0.63,1.02 -1.62,1.86 -2.86,2.4 -2.38,1.03 -4.57,0.76 -6.16,-0.62l-0.14 0.22c0,0 0,-0.01 -0.01,-0.01l-2.69 4.03c0.67,0.47 1.39,0.85 2.14,1.17 2.97,1.24 6.01,1.18 9.01,-0.13 2.17,-0.94 3.87,-2.37 5.03,-4.18l-4.09 -2.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M73.17 35.93l0 22.39 3.48 1.41 -1.97 4.61 -3.85 -1.6c-0.86,-0.37 -1.45,-0.94 -1.89,-1.59 -0.42,-0.66 -0.74,-1.56 -0.74,-2.77l0 -22.45 4.97 0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M82.18 52.62c0,-1.91 0.85,-3.62 2.18,-4.78l-3.57 -3.98c-2.42,2.14 -3.95,5.27 -3.95,8.75 -0.01,3.49 1.52,6.62 3.94,8.76l3.57 -3.98c-1.33,-1.17 -2.17,-2.87 -2.17,-4.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M88.53 58.97c-0.7,0 -1.38,-0.12 -2.01,-0.33l-1.71 5.07c1.17,0.39 2.42,0.6 3.72,0.6 5.65,0.01 10.37,-4 11.46,-9.33l-5.24 -1.08c-0.6,2.9 -3.15,5.07 -6.22,5.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M88.54 40.92c-1.29,0 -2.54,0.21 -3.7,0.6l1.69 5.07c0.63,-0.21 1.31,-0.32 2.01,-0.32 3.07,0 5.64,2.19 6.22,5.09l5.24 -1.06c-1.08,-5.34 -5.8,-9.37 -11.46,-9.38z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEloBrand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/elo-brand.svg";